import React, { useEffect, useRef, useState } from 'react'
import Left_menu from './Left_menu'
import Header from './Header'
import Create_order_nav from './Create_order_nav'
import axios from 'axios'
import queryString from 'query-string';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';


import Swal from 'sweetalert2'

import ReactLoading from 'react-loading';
import config from "../../config"
import { useNetworkState } from 'react-use';

const Wallet_payment_success = () => {
    const { transactionId } = useParams();
    const [state, setState] = useState({ status: 4 });
    const navigate = useNavigate();
  
    const hasCalledRef = useRef(false);
    const pollIntervalRef = useRef(null);
  
    useEffect(() => {
      if (!transactionId) return;
  
      if (!hasCalledRef.current) {
        hasCalledRef.current = true;
        fetchStatus();
  
        // Auto-poll if pending
        pollIntervalRef.current = setInterval(() => {
          fetchStatus();
        }, 5000);
      }
  
      return () => {
        if (pollIntervalRef.current) {
          clearInterval(pollIntervalRef.current);
        }
      };
    }, [transactionId]);
  
    const fetchStatus = async () => {
      try {
        const full_api = config.apiUrl + `/user/payment_transaction_check`;
        const res = await axios.post(
          full_api,
          { transaction_id: transactionId },
          { headers: config.headers }
        );
  
        if (res.data.status && res.data.output) {
          setState(res.data.output);
        }
      } catch (err) {
        console.error("Status fetch error:", err);
      }
    };
  
    const goBackTowallet = () => navigate("/customer/billing_passbook");
    const tryAgainCall = () => navigate("/customer/wallet_recharge");

    return (
        <div>
            {/* <?php include 'meta.php';?> */}
            <Left_menu value={11} />
            {/* <?php include 'left_menu.php';?> */}

            <section class="home ">
                {/* <?php include 'header.php';?>  */}
                <Header />


                <section class="mb-3 mt-3 tools">
                    {/* <div class="container">
                        <h3 class="py-3">Payment {(state.status == 1) ? "Successfull" : (state.status == 2) ? "Pending" : (state.status == 3) ? "Failed" : "Transaction not found."}</h3>
                        <div class="row">
                            <div class="col-12 col-md-4 mb-3">
                                <button class="btn btn-primary btn-block" onClick={goBackTowallet}>Continue</button>
                            </div>
                        </div>
                    </div> */}
                   <div className="container mt-5">
        {state.status == 1 && (
          <div className="alert alert-success text-center">
            <h1>Payment Successful</h1>
            <p>Your payment has been successfully processed.</p>
            <button className="btn btn-primary" onClick={goBackTowallet}>
              Back to Home
            </button>
          </div>
        )}

        {state.status == 2 && (
          <div className="alert alert-warning text-center">
            <h1>Payment Pending</h1>
            <p>Your payment is in process. Please wait...</p>
            <p>We are auto-checking your payment.</p>
          </div>
        )}

        {state.status == 3 && (
          <div className="alert alert-danger text-center">
            <h1>Payment Failed</h1>
            <p>Your payment could not be processed.</p>
            <button className="btn btn-primary" onClick={tryAgainCall}>
              Try Again
            </button>
          </div>
        )}

        {(!state.status || state.status == 4) && (
          <h3 className="text-center">Transaction not found.</h3>
        )}
      </div>
                </section>

            </section>


            {/* <?php include 'footer.php';?> */}
        </div>
    )
}

export default Wallet_payment_success
